<template>
	<div class="uupay-container">

    <UUPayBannerProduct banner-img="app_banner">
      <template v-slot:title>
        <div class="banner-title-uu">指尖輕觸</div>
      </template>
      <template v-slot:subtitle>
        開啟智能運營時代
      </template>
      <template v-slot:info>
        UUPay APP以全流程手機端操作+100%數字化註冊體系，讓申請到運營瞬間完成，收款支付一觸即達。
      </template>
    </UUPayBannerProduct>

    <product-feature :list="productFeatures" />


    <func-feature :title="funcTitle" :list="funcFeatures"/>

    <safe-account :list="safeList" />

    <UUPayBannerContact :info="['我準備好了！你呢？']" />
  </div>
</template>
<script>
import UUPayBannerContact from "@/components/uupayBannerContact";
import ProductFeature from "@/components/ProductFeature";
import UUPayBannerProduct from "@/components/uupayBannerProduct";
import FuncFeature from "@/components/FuncFeature";
import SafeAccount from "@/components/SafeAccount";

export default {
  name: 'UUPayApp',
  components: {
    UUPayBannerContact,
    ProductFeature,
    UUPayBannerProduct,
    FuncFeature,
    SafeAccount
  },
  data() {
    return {
      productFeatures: [
        {id: 0, imgSrc: 'offline_pay', desc: '線下收款'},
        {id: 1, imgSrc: 'realtime_record', desc: '實時流水'},
        {id: 2, imgSrc: 'finance_report', desc: '財務報表'},
        {id: 3, imgSrc: 'remote_manage', desc: '遠程管理'},
      ],
      funcTitle: {
        highLight: '最強大',
        desc: '的數據管理平台',
      },
      funcFeatures: [
        {
          id: 0, imgSrc: 'app_front_mobile', title: '流動智能收款', 
          info: [
            {id: 0, desc: '隨時隨地安全收單，精準匹配零售服務業態需求'},
            {id: 1, desc: '無界支付解決方案，全域觸達消費場景'},
            {id: 2, desc: '信用卡/電子錢包全覆蓋，一機暢通消費路徑'},
            {id: 3, desc: '銀行級安全防護，交易合規零風險'},
          ]
        },
        {
          id: 1, imgSrc: 'app_payment_link', title: '收款連結', 
          info: [
            {id: 0, desc: '無30秒生成專屬收款鏈接，即建即用即收'},
            {id: 1, desc: '一鍵分發定制支付頁面，社交平台/WahtsApp直抵客戶'},
            {id: 2, desc: '自定義倒數折扣活動，精準激活休眠商品'},
            {id: 3, desc: '透過限時優惠創造緊迫感來提高轉換率'},
          ]
        },
        {
          id: 3, imgSrc: 'app_online_income', title: '線上收款', 
          info: [
            {id: 0, desc: '模塊化API5分鐘快速嵌入，零摩擦對接現有業務系統'},
            {id: 1, desc: '支持 180+ 國家本幣收單，實時動態匯率穿透結算'},
            {id: 2, desc: '提供 SDK 矩陣 + 交互式文檔 + 沙箱環境，T+1 完成全流程驗證'},
            {id: 3, desc: '從個體商戶到跨國集團，無流量閾值限制的線性擴展能力'},
          ]
        },

        {
          id: 4, imgSrc: 'app_instant_flow', title: '即時流水監控', 
          info: [
            {id: 0, desc: '全渠道交易流毫秒級聚合，實時掌控百店動態'},
            {id: 1, desc: '多維度業報自動生成，日結效率提升90%'},
            {id: 2, desc: 'AI驅動經營缺口預警，自動推送黃金應對方案'},
          ]
        },
      ],
      safeList: [
        {id: 0, imgSrc: 'app_pci_level', title: 'PCI Level 1', style: {height: '60px', 'margin': '1rem 0 0.3rem 0'},
         desc: '使用端對端加密技術把交易的所有數據加密傳輸，確保信用卡資料保密和交易安全。'},
        {id: 0, imgSrc: 'app_visa', title: 'Visa PayWave', style: {},
         desc: 'Visa PayWave 支援使用 Visa 卡或裝置透過射頻或 NFC 技術進行非接觸式支付，減少信用卡被盗機會。'},
        {id: 0, imgSrc: 'app_master', title: 'Mastercard Paypass', style: {},
         desc: 'Mastercard Paypass 透過 NFC 技術，只需輕觸銀行卡、手機或其他支付設備即可實現快速、簡單的支付。'},
        {id: 0, imgSrc: 'app_unionpay', title: 'UnionPay', style: {},
         desc: '獲銀聯認證之支付平台，可以受理銀聯IC卡進行交易。'},
        {id: 0, imgSrc: 'app_swift', title: 'SVF', style: {},
         desc: '獲香港儲值支付工具牌照，合法營運線上支付、銷售點流動支付、P2P轉帳、實體卡四個方面'},
        {id: 0, imgSrc: 'app_mso', title: 'MSO', style: {},
         desc: '獲得權威批准-代表在港貨幣及外匯市場上獲得了“通行證”，每一筆交易都是接受香港政府監督，100%合規保障。'},
      ]
    }
  },

}
</script>
<style scoped>


.modules-section {
  margin: 100px 0;
}

.modules-section-container {
  max-width: 1440;
}
.modules-section .content {
  background-color: #f8f8f8;
  border-radius: 6px;
}
.modules-section .pos-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 4.5rem 0 2rem 0;
}
.modules-section .title {
  font-size: 30px;
  line-height: 100%;
  color: #21042e;
  margin-bottom: 1rem;
  font-weight: 600;
}
.modules-section .subtitle {
  font-size: 18px;
  line-height: 100%;
  color: #bc68a4;
}
.modules-section .pos-img {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}
.modules-section .pos-img-bg {
  background-image: url('/static/pos_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  width: 186px;
  height: 320px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.modules-section .content-row {
  margin: 40px 0;
}

.why-us-section {
  background-color: #f8f8f8;
  padding: 121px 0;
}
.why-us-section .container {
  max-width: 1440px;
}
.why-us-section .info {
  width: 500px;
  background-color: #fff;
  border-radius: 6px;
  padding: 3rem;
}
.why-us-section .info .question {
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  color: #9a307a;
  margin-bottom: 2.3rem;
}
.why-us-section .info .answer-title {
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  color: #21042e;
  margin-bottom: 1rem;
}
.why-us-section .info .answer-detail {
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  color: #4d4d4d;
}
.why-us-section .info .answer-icon {
  margin: 0.3rem 0.6rem 0 0;

}
</style>


// WEBPACK FOOTER //
// src/views/uupayApp.vue